module.exports = __webpack_public_path__ + "images/mail-grey-dark.7161d0f32ae22f4ffd8ff68665ca33fb.svg";